// import { Component } from '@angular/core';
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { EnvService } from "../env.service";
import { UserService } from "../shared/services/user.service";

import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: "login.pagina.component.html",
  styleUrls: ["login.pagina.component.scss"],
})
// export class LoginComponent {
//     login: string;
//     password: string;
//     selectedValue: any;

//     constructor(private userService: UserService) {
//         console.log('check if user logged in?');

//      }

//     refreshValue = (value: any) => this.selectedValue = value;
//     // userLogin = () => this.userService.login();

//     userLogin() {
//         console.log('login');
//     }

// }
export class LoginComponent implements OnInit {
  login: string;
  password: string;
  selectedValue: any;

  encodedUser: string;

  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    private env: EnvService
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      var jwt = params["jwt"];
      // console.log("jwt", jwt);

      if (jwt) {
        this.userService.loginUser(jwt);
      }
    });
  }

  refreshValue = (value: any) => (this.selectedValue = value);

  userLogin() {
    var returnUrl = this.env.apibase + "authenticate/saml/redirect";
    var basispoortLoginUrl = this.env.basispoort_login + returnUrl;

    window.location.href = basispoortLoginUrl;
  }
}
